import script from "./UnifiedPagination.vue?vue&type=script&setup=true&lang=ts"
export * from "./UnifiedPagination.vue?vue&type=script&setup=true&lang=ts"

import "./UnifiedPagination.vue?vue&type=style&index=0&id=4fd764c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fd764c0"]])

export default __exports__